// components/ForcePasswordChangeRedirect.tsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux'; // or useContext(AuthContext)
import { useAppSelector } from '@app/hooks/reduxHooks';

export const ForcePasswordChangeRedirect: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const user = useAppSelector((state) => state.user.user);
  const location = useLocation();


  if (user?.isFirstTimeLogin && location.pathname !== '/users/ChangePassword') {
    return <Navigate to="/users/ChangePassword" replace />;
  }

  return <>{children}</>;
};
